import React, { useState } from 'react';

import { Segment } from '@modules/common/components/Segment';
import { Accordion } from '@modules/common/components/Accordion';

import { OAuthClientDescriptor } from '../../../components/types/oauth-client';
import Client from './Client';

type Props = {
  clients: OAuthClientDescriptor[];
  editable?: boolean;
  onClientUpdated?: () => void;
};

function ClientsList({ clients, editable, onClientUpdated }: Props) {
  const [activeIndex, setActiveIndex] = useState<number>(-1);

  if (clients.length === 0) {
    return (
      <Segment
        content="No clients."
        textAlign="center"
        padded="very"
        size="large"
        style={{ borderRadius: 0 }}
      />
    );
  }
  return (
    <Accordion styled fluid style={{ borderRadius: 0 }}>
      {clients.map((client, i) => (
        <Client
          key={client.clientId}
          client={client}
          index={i}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          onClientUpdated={onClientUpdated}
          editable={editable}
        />
      ))}
    </Accordion>
  );
}

export default ClientsList;
